export default "__VITE_ASSET__B8Ec7IcM__"